<template>
  <div class="top-bar">
    <div class="row top-bar-content">
      <div class="row top-bar-left">
        <div class="row logo-container">
          <div @click="onToHomeClick">
            <img  class="logo" src="../../assets/img/logo.svg" alt="shannon logo" />
          </div>
            <div @click="onToHomeClick" class="logo-text">舆情监控系统</div>
        </div>
        <div class="row header-tabs">
          <div
            class="header-tabs-item" 
            :class="{'tabs-item-active': item.name === selectedOptionTab}" 
            v-for="item in headerTabs" 
            :key="item.path"
            @click="onTabClick(item)"
            >
              {{ item.name }}
          </div>
        </div>
      </div>
      <div class="row top-bar-right">
        <div class="row search-right">
          <user-count></user-count>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserCount from '@/components/common/UserCount';
import authService from '@/services/authService';

export default {
  data() {
    return {
      username: '',
      selectedOptionTab: '',
      isFocus: false,
      headerTabs: [
        {
          name: '推荐',
          path: '/'
        },
        {
          name: '热榜',
          path: '/hot-list'
        },
        {
          name: '关注',
          path: '/concern'
        },
        {
          name: '全网',
          path: '/whole-network'
        },
        {
          name: '图谱',
          path: '/graph'
        }
      ]
    };
  },
  props: {
    searchText: {
      type: String,
      default: ''
    }
  },
  methods: {
    onTabClick(res) {
      this.selectedOptionTab = res.name;
      this.$router.push({
        path: res.path
      });
    },
    onToIndustryPageClick() {
      this.selectedOptionTab = 'industry';
      this.$router.push({
        path: '/industry-page'
      });
    },
    onToHomeClick() {
      this.selectedOptionTab = '推荐';
      this.$router.push({
        path: '/'
      });
    },
    onToMainPageClick() {
      this.selectedOptionTab = 'main';
      this.$router.push({
        path: '/'
      });
    },
    onSearchInputChange(searchText) {
      this.$emit('change', searchText);
      this.isShowSearchInput = false;
    },
    onSearchCompany(searchText) {
      this.$emit('searchCompany', searchText);
      this.isShowSearchInput = false;
    },
    showSearchInput() {
      this.isShowSearchInput = true;
    },
    closeSearchInput() {
      this.isShowSearchInput = false;
    },
    onFocus(status) {
      this.isFocus = status;
    }
  },
  components: {
    UserCount
  },
  mounted() {
    eventBus.$on('toOtherPage', () => {
      this.selectedOptionTab = '';
    });
    document.addEventListener('click', this.closeSearchInput);
    this.username = authService.getLoggedUserName();
    this.headerTabs.forEach(item => {
      if (item.path === this.$route.path) {
        this.selectedOptionTab = item.name;
      }
    });
  }
};
</script>

<style lang="scss" scoped>
$bgColor: #3d414f;

.top-bar {
  height: 60px;
  padding-top: 17px;
  border-bottom: 1px solid #656164;
  background-color: $bgColor;
  z-index: 2;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  .top-bar-content {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    width: 1200px;
    .top-bar-left {
      .header-tabs {
        margin-top: 3px;
        height: 26px;
        .header-tabs-item {
          margin-left: 40px;
          color: rgba(255, 255, 255, 0.7);
          font-size: 14px;
          cursor: pointer;
          &:hover {
            color: #ffffff;
          }
        }
        .tabs-item-active {
          position: relative;
          color: #ffffff;
        }
        .tabs-item-active::after {
          content: "";
          position: absolute;
          top: 25px;
          left: 7px;
          width: 14px;
          height: 3px;
          background-color: #ffffff;
        }
      }
    }
    .logo-container {
      height: 26px;
      align-items: center;

      .logo {
        display: block;
        width: 26px;
        height: 26px;
        cursor: pointer;
      }

      .logo-text {
        margin-left: 12px;
        font-weight: bold;
        color: white;
        cursor: pointer;
      }
    }

    .top-bar-right {
      .search-input {
        width: 244px;
      }
      .normal{
        width: 244px;
        transition: all .3s;
        -ms-transition:all .3s;
        -moz-transition:all .3s;
        -webkit-transition:all .3s;
        -o-transition:all .3s;
      }
      .widen{
        width: 480px;
        transition: all .3s;
        -ms-transition:all .3s;
        -moz-transition:all .3s;
        -webkit-transition:all .3s;
        -o-transition:all .3s;
      }
      .search-right {
        position: relative;
        top: -4px;
      }
      .edit-notification-icon {
        margin-left: 40px !important;
        margin-top: 3px !important;
      }
      .search-icon {
        width: 24px;
        height: 24px;
        margin-top: 3px;
        cursor: pointer;
      }
    }
  }

  .top-router {
    width: 400px;
    margin: -26px auto;
    .router-link-exact-active::after {
      content: "";
      position: absolute;
      top: 37px;
      right: 21px;
      width: 18px;
      height: 4px;
      background-color: #45a8cc;
    }

    .top-router-sentiment {
      margin-right: 48px;
    }

    .top-router-tab {
      position: relative;
      width: 56px;
      color: #ffffff;
      font-size: 14px;
      cursor: pointer;
    }

    .active-home::after {
      content: "";
      position: absolute;
      top: 37px;
      right: 21px;
      width: 18px;
      height: 4px;
      background-color: #45a8cc;
    }

    .active::after {
      content: "";
      position: absolute;
      top: 37px;
      right: 21px;
      width: 18px;
      height: 4px;
      background-color: #45a8cc;
    }

    .top-router-tab:first-child {
      margin-left: 48px;
    }
    .top-router-tab:last-child {
      margin-left: 48px;
      margin-right: 48px;
    }
  }
}
a {
  text-decoration: none;
}

.router-link-active {
  text-decoration: none;
}
</style>

